import {
  DEFAULT_NA,
  PROFILE_SUBNAME,
  RESULT_STATE,
} from '../newrelic-constants';

import {
  getEnvironmentMicro,
  getFfnAMR,
} from '../newrelic-helpers';

export function nrBalance(globalState, actionName, fullStory, metricData) {
  const request = metricData?.resultState === RESULT_STATE.FAILURE ? JSON.stringify(metricData.rqResult.request) : DEFAULT_NA;

  const data = {
    actionSubname: PROFILE_SUBNAME.WEBBALANCE,
    environment: getEnvironmentMicro(),
    fullstory: fullStory || DEFAULT_NA,
    resultState: metricData?.resultState,
    storefront: metricData?.storefront,
    flow: 'MYB',
    subflow: metricData?.action?.subflow,
    errorCode: metricData?.action?.errorCode || DEFAULT_NA,
    request: request,
    url: window?.location?.href,
    pointsBalance: metricData?.action?.response?.pointsBalance || DEFAULT_NA,
    qualifyingPoints: metricData?.action?.response?.qualifyingPoints || DEFAULT_NA,
    tierAMR: metricData?.action?.response?.code_tier || DEFAULT_NA,
    ffn: getFfnAMR(),
  };
  window.newrelic.addPageAction(actionName, data);
}
